// ** MUI Imports
import Box from "@mui/material/Box";
import WeatherNight from "mdi-material-ui/WeatherNight";
import WhiteBalanceSunny from "mdi-material-ui/WhiteBalanceSunny";

// ** Hooks + shared account menu (reused)
import { useSettings } from "src/@core/hooks/useSettings";
import UserDropdown from "src/layouts/components/UserDropdown";

/******************************************************************
 * ##: FlixLayout
 * Full-bleed shell for the Flix catalog. Deliberately does NOT use the
 * app's UserLayout (no sidebar/appbar/footer) — the Flix look is a
 * separate, self-contained chrome. Background follows the MUI theme so
 * the neutral placeholder works in light and dark.
 * @param {Object} props - { children }
 * @returns {JSX.Element} - the `.flix` shell
 * History:
 * 22-07-2026: Created
 ******************************************************************/
const FlixLayout = ({ children }) => {
  const { settings, saveSettings } = useSettings();
  const isDark = settings?.mode === "dark";

  const toggleMode = () => {
    saveSettings({ ...settings, mode: isDark ? "light" : "dark" });
  };

  return (
    <Box className="flix" sx={{ bgcolor: (theme) => (theme.palette.mode === "dark" ? "#141414" : "background.default"), color: "text.primary", minHeight: "100vh" }}>
      <header className="flix-topbar">
        <Box component="img" src="/images/logos/logo-horizontal.png" alt="SalesPark Academy" sx={{ height: 34, display: "block" }} />
        <div className="flix-topbar__right">
          <button type="button" className="flix-icon-btn" onClick={toggleMode} aria-label="Alternar tema">
            {isDark ? <WhiteBalanceSunny /> : <WeatherNight />}
          </button>
          <UserDropdown settings={settings} />
        </div>
      </header>
      <main className="flix-main">{children}</main>
    </Box>
  );
};

export default FlixLayout;
